import { render, staticRenderFns } from "./rightBanner.vue?vue&type=template&id=512d84c8&scoped=true&"
import script from "./rightBanner.vue?vue&type=script&lang=js&"
export * from "./rightBanner.vue?vue&type=script&lang=js&"
import style0 from "./rightBanner.vue?vue&type=style&index=0&id=512d84c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d84c8",
  null
  
)

export default component.exports